export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const GET_ASSOCIATION_USERS = "GET_ASSOCIATION_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const TENANT_SELECTED = "TENANT_SELECTED";
